"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _linkList = _interopRequireDefault(require("../link-list"));
var _heading = _interopRequireDefault(require("../heading"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** LinkListColumn is a simple block-level column of a `Heading` followed by a `LinkList`.
 */
var LinkListColumn = function LinkListColumn(_ref) {
  var className = _ref.className,
    headingText = _ref.headingText,
    links = _ref.links,
    headingProps = _ref.headingProps,
    _ref$linkClassName = _ref.linkClassName,
    linkClassName = _ref$linkClassName === void 0 ? '' : _ref$linkClassName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_heading["default"], _extends({
    className: "mb4"
  }, headingProps), headingText), /*#__PURE__*/_react["default"].createElement(_linkList["default"], {
    inlineAboveBreakpoint: null,
    linkClassName: "mb2 py2 ".concat(linkClassName),
    links: links
  }));
};
LinkListColumn.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Applied to the div surrounding the column */
  className: _propTypes["default"].string,
  /** An array of links to be rendered in the column; fed to `LinkList` */
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** The text of the link */
    text: _propTypes["default"].any.isRequired,
    /** The href of the link */
    href: _propTypes["default"].string,
    /**
     * Tag for the link, defaults to a standard anchor
     */
    tagName: _propTypes["default"].any,
    /**
     * When using React Router, the links will often receive a 'to' prop
     */
    to: _propTypes["default"].string
  })),
  /** Props to pass through to `Heading`, including `tagName`, `size`, `className`, etc. */
  headingProps: _propTypes["default"].shape({
    tagName: _propTypes["default"].any.isRequired,
    size: _propTypes["default"].string
  }),
  /** The text sent as the heading */
  headingText: _propTypes["default"].any.isRequired,
  /** Class applied to all links */
  linkClassName: _propTypes["default"].string
} : {};
LinkListColumn.displayName = 'LinkListColumn';
var _default = exports["default"] = LinkListColumn;